import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BymeService } from './services/byme.service';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'ng-hbm-bdi-root',
  template: `
    <ng-hbm-bdi-banner *ngIf="showBanner"></ng-hbm-bdi-banner>
    <router-outlet></router-outlet>
    <ng-hbm-bdi-modals></ng-hbm-bdi-modals>
  `,
  styles: []
})
export class AppComponent {
  showBanner: boolean = true;

  constructor(translate: TranslateService, byMeService:BymeService,  private router: Router){

    byMeService.initService();
    
    translate.setDefaultLang('es');

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.showBanner = !event.url.includes('/error'); // Masquer la bannière sur la page d'erreur
      }
    });
  }
}
